import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DeleteOutlined } from '@mui/icons-material';

import { Button, Input, Modal } from 'components/ui';

import * as Styled from './EmailFormModal.styles';

const schema = Yup.object({
  name: Yup.string().trim().required('Pole wymagane'),
  email: Yup.string().trim().email('Niepoprawny email').required('Pole wymagane'),
});

export const EmailFormModal = ({ data, onClose, onConfirm, onDelete, isSaving }) => {
  const { values, errors, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      name: data.name || '',
      email: data.email || '',
    },
    validationSchema: schema,
    validateOnChange: false,
    onSubmit: (values) => {
      onConfirm(schema.cast(values));
    },
  });

  return (
    <Modal title={data.email ? 'Edytuj adres e-mail' : 'Nowy adres e-mail'} onClose={onClose}>
      <Styled.Form>
        <Input
          onChange={(value) => setFieldValue('name', value)}
          value={values.name}
          label="Nazwa*"
          error={errors.name}
        />
        <Input
          onChange={(value) => setFieldValue('email', value)}
          value={values.email}
          label="Adres email*"
          error={errors.email}
        />

        <Styled.Actions>
          <div>
            {data.email && (
              <Button onClick={onDelete} color="error" variant="text">
                <DeleteOutlined /> Usuń
              </Button>
            )}
          </div>

          <div>
            <Button onClick={onClose} variant="outlined">
              Anuluj
            </Button>
            <Button onClick={handleSubmit} loading={isSaving}>
              Zapisz
            </Button>
          </div>
        </Styled.Actions>
      </Styled.Form>
    </Modal>
  );
};

EmailFormModal.propTypes = {
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  isSaving: PropTypes.bool,
};
